/* == from section custom_liquid_t8QmNX == */
;
(function(){
  var sec = document.querySelector('.olivia-fit'); if(!sec) return;
  var SZS='(max-width: 768px) 46vw, 490px';
  // preload both size states (responsive candidates) so the Queen/Double toggle swaps instantly
  sec.querySelectorAll('.dimg').forEach(function(img){
    ['queen','double'].forEach(function(a){
      var u=img.getAttribute('data-'+a+'-src'); var s=img.getAttribute('data-'+a+'-set');
      if(u){ var i=new Image(); i.sizes=SZS; if(s){ i.srcset=s; } i.src=u; }
    });
  });
  function apply(size){
    sec.querySelectorAll('.dimg').forEach(function(img){
      var u=img.getAttribute('data-'+size+'-src'); var s=img.getAttribute('data-'+size+'-set');
      if(u && img.getAttribute('src') !== u){ if(s){ img.srcset=s; } img.src=u; }
    });
  }
  var btns = sec.querySelectorAll('.fit-toggle button');
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      btns.forEach(function(x){ x.classList.toggle('on', x===b); });
      apply(b.getAttribute('data-fit'));
    });
  });
  apply('queen');
})();

/* == from section custom_liquid_XmTkk8 == */
;
(function(){
  if(window.location.pathname.indexOf('/products/olivia-queen-murphy-cabinet-bed-with-mattress')===-1) return;
  var bar=document.getElementById('olivia-sticky-atc'); if(!bar) return;
  bar.style.display='';
  function getMainAtcBtn(){return document.getElementById('elite-atc-btn')||document.querySelector('form[action="/cart/add"] button[type="submit"]')||document.querySelector('.product-form__submit')||document.querySelector('button[name="add"]');}
  function getBuyBox(){return document.querySelector('[id*="__main"] .product__info-container')||document.querySelector('.product__info-wrapper')||document.querySelector('.product-form')||getMainAtcBtn();}
  function checkVisibility(){var btn=getMainAtcBtn(); if(!btn){bar.classList.remove('visible');return;} var r=btn.getBoundingClientRect(); if(r.bottom<0) bar.classList.add('visible'); else bar.classList.remove('visible');}
  var ticking=false;
  window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(function(){checkVisibility();ticking=false;}); ticking=true; } },{passive:true});
  window.addEventListener('resize',checkVisibility);

  /* ---- variant mirroring: dynamic price + real add-to-cart ---- */
  var stickyBtn=document.getElementById('ol-sticky-btn');
  var priceEl=document.getElementById('ol-sticky-price');
  var defaultBtnHTML=stickyBtn?stickyBtn.innerHTML:'Add to Cart';
  var variants=[];

  function fmtMoney(cents){
    var d=(cents/100).toFixed(2),p=d.split('.');
    p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return (p[1]==='00')?'$'+p[0]+'.00':'$'+p[0]+'.'+p[1];
  }
  // The picker: standard Dawn variant-radios for this product's main section.
  function pickerRoot(){
    return document.querySelector('variant-radios[data-section*="__main"]')
        || document.querySelector('variant-selects[data-section*="__main"]')
        || document.querySelector('variant-radios')
        || document.querySelector('variant-selects')
        || document.querySelector('.product-form__input');
  }
  function selectedOption(name){
    var r=document.querySelector('variant-radios input[name="'+name+'"]:checked, variant-selects input[name="'+name+'"]:checked');
    if(r) return r.value;
    var s=document.querySelector('variant-selects select[name="'+name+'"]');
    if(s) return s.value;
    return null;
  }
  // Resolve the variant the shopper is currently looking at, by matching the checked options.
  function currentVariant(){
    if(!variants.length) return null;
    var o1=selectedOption('Color'), o2=selectedOption('Size');
    var match=variants.filter(function(v){
      return (o1==null||v.option1===o1) && (o2==null||v.option2===o2);
    });
    if(match.length===1) return match[0];
    // Fallback: trust the form's hidden id input if option matching is ambiguous.
    var idIn=document.querySelector('form[action*="/cart/add"] [name="id"]');
    if(idIn&&idIn.value){
      var byId=variants.filter(function(v){return String(v.id)===String(idIn.value);});
      if(byId.length) return byId[0];
    }
    return match.length?match[0]:null;
  }
  function syncPrice(){
    var v=currentVariant();
    if(v&&priceEl) priceEl.textContent=fmtMoney(v.price);
  }
  function pulsePicker(){
    var root=pickerRoot(); if(!root) return;
    root.classList.remove('ol-picker-pulse');
    void root.offsetWidth; // restart animation
    root.classList.add('ol-picker-pulse');
    setTimeout(function(){ root.classList.remove('ol-picker-pulse'); },2100);
  }
  function scrollToPicker(){
    var box=getBuyBox()||pickerRoot()||document.querySelector('.product');
    if(box){ var y=box.getBoundingClientRect().top+window.pageYOffset-80; window.scrollTo({top:Math.max(0,y),behavior:'smooth'}); }
    else { window.scrollTo({top:0,behavior:'smooth'}); }
  }

  // Load variants (id/price/available) then wire price syncing.
  fetch('/products/olivia-queen-murphy-cabinet-bed-with-mattress.js')
    .then(function(r){return r.json();})
    .then(function(pr){ variants=pr.variants||[]; syncPrice(); })
    .catch(function(){});

  // Keep sticky price in lockstep with any variant change (radios, select, or custom size cards).
  document.addEventListener('change',function(e){
    if(e.target&&(e.target.name==='Color'||e.target.name==='Size'||e.target.name==='id')) syncPrice();
  });

  if(stickyBtn){
    stickyBtn.addEventListener('click',function(){
      var v=currentVariant();
      var mainBtn=getMainAtcBtn();
      var canAdd=mainBtn && !mainBtn.disabled && v && v.available!==false;
      if(canAdd){
        mainBtn.click(); // proven proxy: fires Dawn <product-form> AJAX add + cart drawer + tracking hooks
        stickyBtn.innerHTML='Added ✓';
        stickyBtn.classList.add('is-added');
        stickyBtn.disabled=true;
        setTimeout(function(){
          stickyBtn.innerHTML=defaultBtnHTML;
          stickyBtn.classList.remove('is-added');
          stickyBtn.disabled=false;
        },2200);
      } else {
        // No valid/available selection: send them to the picker and draw the eye to it.
        scrollToPicker();
        pulsePicker();
      }
    });
  }
})();

/* == from section ff_pdp_scale == */
;
(function(){
  function init(){
    var slider=document.querySelector('.thumbnail-slider'), list=document.querySelector('.thumbnail-list');
    if(!slider||!list||slider.querySelector('.ff-more')) return;
    function img(){ return document.querySelector('.product__media-item.is-active .product__media')||document.querySelector('.product__media'); }
    var badge=document.createElement('div'); badge.className='ff-more'; badge.setAttribute('hidden','');
    badge.appendChild(document.createElement('span'));
    slider.appendChild(badge);
    var off=0, cap=0;
    function desktop(){ return window.matchMedia && matchMedia('(min-width:990px)').matches; }
    function items(){ return Array.prototype.filter.call(list.querySelectorAll('.thumbnail-list__item'), function(t){ return t.getBoundingClientRect().height>0; }); }
    function maxoff(){ return Math.max(0, list.scrollHeight - cap); }
    function sync(){
      if(!desktop()||cap<=0){ badge.setAttribute('hidden',''); return; }
      var winB=off+cap, h=0;
      items().forEach(function(t){ if(t.offsetTop + t.offsetHeight > winB + 2) h++; });
      if(h>0){ badge.firstChild.textContent='+'+h; badge.removeAttribute('hidden'); } else badge.setAttribute('hidden','');
    }
    function apply(){ list.style.setProperty('--ff-off', off+'px'); sync(); }
    function setCap(){
      var m=img(); if(!m) return;
      if(!desktop()){ slider.style.removeProperty('--ff-cap'); off=0; list.style.setProperty('--ff-off','0px'); badge.setAttribute('hidden',''); return; }
      var h=Math.round(m.getBoundingClientRect().height);
      if(h<=0){ var g=slider.closest('media-gallery')||slider.parentElement; if(g) h=Math.round(g.getBoundingClientRect().height); }
      if(h<=0) return; /* never collapse the rail: video media reports 0 height while loading/playing */
      cap=h; slider.style.setProperty('--ff-cap', cap+'px');
      off=Math.min(off, maxoff()); apply();
    }
    badge.addEventListener('click', function(){ var mo=maxoff(); off=(off>=mo-1)?0:Math.min(mo, off+Math.round(cap*0.85)); apply(); });
    slider.addEventListener('wheel', function(e){ var mo=maxoff(); if(!desktop()||mo<=0) return; var nx=Math.min(mo, Math.max(0, off+e.deltaY)); if(nx!==off){ e.preventDefault(); off=nx; apply(); } }, {passive:false});
    var mi=img()&&img().querySelector('img'); if(mi){ if(mi.complete) setCap(); mi.addEventListener('load', setCap); }
    setCap();
    [150,450,1000].forEach(function(t){ setTimeout(setCap,t); });
    var tm; window.addEventListener('resize', function(){ clearTimeout(tm); tm=setTimeout(setCap,150); });
    document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.thumbnail-list__item')){ setTimeout(setCap,120); } }, true);
    document.addEventListener('play', function(){ setCap(); setTimeout(setCap,120); setTimeout(setCap,400); }, true);
    document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.product__media-item, .deferred-media, .product__modal-opener')){ [60,200,500,900].forEach(function(t){ setTimeout(setCap,t); }); } }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
